import { render, staticRenderFns } from "./skillView.vue?vue&type=template&id=27432a42&scoped=true&"
import script from "./skillView.vue?vue&type=script&lang=js&"
export * from "./skillView.vue?vue&type=script&lang=js&"
import style0 from "./skillView.vue?vue&type=style&index=0&id=27432a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27432a42",
  null
  
)

export default component.exports